import { CafsType } from "./cafsType";

export const CafsMap: Map<CafsType, string> = new Map([
  [CafsType.Tree, "perennial"],
  [CafsType.Crop, "annual"],
  [CafsType.Input, "input"],
]);
